import React from 'react';

const IconMinus = (props) => {

  return (
    <svg width="17" height="2" viewBox="0 0 17 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="17" height="2" fill="#C4C4C4"/>
    </svg>
  );
}

export default IconMinus;